<template>
	<div class="globalActivity">
		<el-form ref="form" :model="form" :rules="rules" label-width="170px" label-position="top" :disabled="preViewFlag">
			<el-form-item prop="checkedCities">
				<span slot="label" class="slot-label f-s-18">一、方案选择</span>
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				<el-checkbox-group v-model="form.checkedCities" @change="handleCheckedCitiesChange">
					<el-checkbox v-for="item in cities" :label="item.value" :key="item.label">{{item.label}}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item v-show="form.checkedCities.length>0 || this.$route.query.status === '2'">
				<span slot="label" class="slot-label f-s-18">二、方案配置</span>
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item v-if="form.checkedCities.includes('5')" title="转盘奖励" name="5">
						<el-container>
							<el-aside width="68%">
								<el-table border :data="form.infiledList" v-model="form.infiledList" style="width: 95%">
									<el-table-column label="名次" width="70px">
										<template slot-scope="scope">
											<span v-if="scope.row.prizeNum !== '感谢参与'">{{ scope.row.prizeNum }}等奖</span>
											<span v-else>{{ scope.row.prizeNum}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="amt" label="奖励金额">
										<template slot-scope="scope">
											<el-input-number
												v-if="scope.row.prizeNum !== '感谢参与'"
												:disabled="scope.row.unit==='张'" size="mini" :min="0"
												:max="9999999.99"
												oninput="if(value.length>7){value=value.slice(0,7)}"
												auto-complete="off" :precision="2" :controls="false"
												v-model="scope.row.amt">
											</el-input-number>
											<span v-else>0</span>
										</template>
									</el-table-column>
									<el-table-column prop="coin" label="奖励翼币">
										<template slot-scope="scope">
											<el-input v-if="scope.row.prizeNum !== '感谢参与'" size="mini" :min="1" :max="999999999" type="number" oninput="if(value.length>9)value=value.slice(0,9)" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.coin"></el-input>
											<span v-else>0</span>
										</template>
									</el-table-column>
									<el-table-column label="翼卡" width="100px">
										<template slot-scope="scope">
											<div v-if="scope.row.prizeNum !== '感谢参与'" style="display: flex;justify-content: space-between">
												<el-button type="text" @click="scope.row.ykVisible = true">
												{{
													scope.row.cardId === 0 ? '选择翼卡' : Object.values(ykData).flat().find(
													it => it.id === scope.row.cardId) ? Object.values(
													ykData).flat().find(it => it.id === scope.row.cardId).cardName
													: scope.row.cardId
												}}
												</el-button>
												<el-button v-if="scope.row.cardId!==0" type="text" @click="scope.row.cardId = 0">取消</el-button>
											</div>
											<span v-else>--</span>
											<el-dialog :modal="false" title="选择翼卡" :visible.sync="scope.row.ykVisible" center width="25%">
												<el-tabs type="border-card">
													<el-tab-pane label="金卡">
													<el-radio-group style="display: grid" v-model="scope.row.cardId">
														<el-radio style="padding: 5px" v-for="(item, index) in ykData[1]" :key="index" :label="item.id">
															{{ item.cardName }}
														</el-radio>
													</el-radio-group>
													</el-tab-pane>
													<el-tab-pane label="银卡">
													<el-radio-group style="display: grid" v-model="scope.row.cardId">
														<el-radio style="padding: 5px" v-for="(item, index) in ykData[2]" :key="index" :label="item.id">
															{{ item.cardName }}
														</el-radio>
													</el-radio-group>
													</el-tab-pane>
													<el-tab-pane label="铁卡">
													<el-radio-group style="display: grid" v-model="scope.row.cardId">
														<el-radio style="padding: 5px" v-for="(item, index) in ykData[3]" :key="index" :label="item.id">
															{{ item.cardName }}
														</el-radio>
													</el-radio-group>
													</el-tab-pane>
												</el-tabs>
											</el-dialog>
										</template>
									</el-table-column>
									<el-table-column prop="percent" label="概率" width="150px">
										<template slot-scope="scope">
											<el-input v-if="scope.$index === 0" size="mini" :min="1" type="number" :step="0.01"  :max="99.99" oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}" v-model="scope.row.percent">
												<template slot="append">%</template>
											</el-input>
											<el-input v-else size="mini" :min="0.01" type="number" :step="0.01" :max="99.99" oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}" v-model="scope.row.percent">
												<template slot="append">%</template>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="rewardNum" label="获奖人次">
										<template slot-scope="scope">
											<el-input v-if="scope.row.prizeNum !== '感谢参与'" size="mini" :min="1" :max="999999999" type="number" oninput="if(value.length>9)value=value.slice(0,9)" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.rewardNum"></el-input>
											<span v-else>0</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" min-width="40px">
										<template slot-scope="scope">
											<el-button type="danger" icon="el-icon-delete" title="删除一行" circle
												v-show="scope.$index === form.infiledList.length-1 && form.infiledList.length>3"
												@click.native.prevent="deleteRow(scope.$index, form.infiledList,1)"
												size="small">
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							<div class="self-add">
								<i v-show="form.infiledList.length<7 && !preViewFlag" title="新增一行" class="el-icon-circle-plus-outline" @click="addRow(form.infiledList,1)"></i>
							</div>
							<el-row class="self-font p-t-10">
								<el-col class="f-s-16">抽奖次数设置：</el-col>
								<el-col>
									<el-form-item prop="perTime">
										<el-input style="width: 400px"
												onkeyup="if(this.value.length===1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
												v-model.number="form.perTime" controls-position="right"
												:min="1" step="1">
										<template slot="prepend">轻打标/轻审核/轻翻译</template>
										<template slot="append">抽奖一次</template>
										</el-input>
									</el-form-item>
								</el-col>
							</el-row>
							</el-aside>
							<el-main>
							<el-row class="self-font f-s-16">适用流程：</el-row>
							<el-row>
								<el-form-item prop="applicationFlow">
									<el-checkbox-group v-model="form.applicationFlow">
										<el-checkbox label="2" name="applicationFlow">轻打标</el-checkbox>
										<el-checkbox label="3" name="applicationFlow">轻翻译</el-checkbox>
										<el-checkbox label="4" name="applicationFlow">轻审核</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-row>
							<el-form label-width="100px" size="mini" :model="form">
								<el-row v-show="this.$route.query.status === '2' || this.currentGlobalOperation !== null">
									<el-button type="primary" icon="el-icon-trophy-1" @click="awardVisibleFn">获奖详情</el-button>
									<el-dialog :title="'转盘抽奖 获奖人数：'+gridObj.num + '         花费奖品：' +gridObj.coin +'个翼币   '+gridObj.cardNum +'张翼卡   '+gridObj.amt +'元现金'" :visible.sync="awardVisible">
										<div slot="title" class="dialog-title">
											<el-row style="font-size: 18px">
												<el-col span="4"><span class="title-text">转盘抽奖</span></el-col>
												<el-col span="4"><span>获奖人数:{{ gridObj.num }}人</span></el-col>
												<el-col span="6"><span>花费奖品:{{ gridObj.coin }}个翼币</span></el-col>
												<el-col span="4"><span>{{ gridObj.cardNum }}张翼卡</span></el-col>
												<el-col span="4"><span>{{ gridObj.amt }}元现金</span></el-col>
											</el-row>
										</div>
										<avue-crud ref="crud" :option="tableOption" @size-change="sizeChange" @current-change="currentChange" @on-load="((page, params)=>{getList(page,params,1)})" :data="gridData" :page.sync="page">
											<template slot="createTime" slot-scope="scope">
												<span>{{ scope.row.status !==1?(scope.row.createTime?formatDate(scope.row.createTime):'--'):'--' }}</span>
											</template>
										</avue-crud>
									</el-dialog>
								</el-row>
							</el-form>
							</el-main>
						</el-container>
					</el-collapse-item>
					<el-collapse-item v-if="form.checkedCities.includes('6')" title="天降惊喜" name="6">
						<el-container>
							<el-aside width="68%">
								<el-table border :data="form.infiledList2" v-model="form.infiledList2" style="width: 95%">
									<el-table-column label="选择类型" width="100px">
										<template slot-scope="scope">
											<el-checkbox v-if="scope.row.unit" @change="checkType" v-model="scope.row.checked">{{scope.row.title}}</el-checkbox>
											<span v-else>无</span>
										</template>
									</el-table-column>
									<el-table-column prop="content" label="获奖内容" width="220px">
										<template slot-scope="scope">
											<el-input v-if="scope.row.unit && scope.row.unit == '张'" :disabled="scope.row.unit==='张'" size="mini" :min="0" :max="999999999" type="number" oninput="if(value.length>9)value=value.slice(0,9)" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.content">
												<template slot="append">{{scope.row.unit}}</template>
											</el-input>
											<div v-else-if="scope.row.unit == '个'" class="rangeBox d-f align-c">
												<el-input 
													class="w-120"
													size="mini" :min="0" :max="999999999" type="number" 
													oninput="if(value.length>9)value=value.slice(0,9)" 
													onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" 
													v-model.number="scope.row.startValue">
												</el-input>
												<span>-</span>
												<el-input size="mini" :min="0" 
													:max="999999999" type="number" 
													oninput="if(value.length>9)value=value.slice(0,9)" 
													onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" 
													v-model.number="scope.row.endValue">
													<template slot="append">{{scope.row.unit}}</template>
												</el-input>
											</div>
											<div v-else-if="scope.row.unit === '元'" class="rangeBox d-f align-c">
												<el-input-number
													class="w-124"
													size="mini" :min="0"
													auto-complete="off" :precision="2" :controls="false"
													:max="9999999.99"
													oninput="if(value.length>7)value=value.slice(0,7)"
													v-model="scope.row.startValue">
												</el-input-number>
												<span>-</span>
												<el-input-number
													class="w-120"
													size="mini" :min="0"
													auto-complete="off" :precision="2" :controls="false"
													:max="9999999.99"
													oninput="if(value.length>7)value=value.slice(0,7)"
													v-model="scope.row.endValue">
												</el-input-number>
												<div class="self-num">元</div>
											</div>
											<span v-else>无</span>
										</template>
									</el-table-column>
									<el-table-column prop="limitValue" label="奖励上限">
										<template slot-scope="scope">
											<el-input v-if="scope.row.unit && scope.row.unit !== '元'" 
												size="mini" 
												:min="0" :max="999999999" 
												type="number" 
												oninput="if(value.length>9)value=value.slice(0,9)" 
												onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" 
												v-model.number="scope.row.limitValue">
												<template slot="append">{{scope.row.unit}}</template>
											</el-input>
											<div v-else-if="scope.row.unit === '元'" style="display: flex">
												<el-input-number
													size="mini" :min="0"
													auto-complete="off" :precision="2" :controls="false"
													:max="9999999.99"
													oninput="if(value.length>7)value=value.slice(0,7)"
													v-model="scope.row.limitValue">
												</el-input-number>
												<div class="self-yuan">元</div>
											</div>
											<span v-else>无</span>
										</template>
									</el-table-column>
									<el-table-column prop="percent" label="出现概率" width="180px">
										<template slot-scope="scope">
											<el-input v-if="scope.$index === 0" size="mini" :min="0.01" type="number" :max="99.99" :step="0.01" 
												oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}" 
												v-model="scope.row.percent"
												@change="checkType"
											>
												<template slot="append">%</template>
											</el-input>
											<el-input v-else size="mini" :min="0.01" type="number" :max="99.99" :step="0.01"  
												oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}" 
												v-model="scope.row.percent"
												@change="checkType"
											>
												<template slot="append">%</template>
											</el-input>
										</template>
									</el-table-column>
								</el-table>
								<div class="totalBox" v-if="!preViewFlag">合计：{{probabilityTotal}}%</div>
							</el-aside>
							<el-main>
								<el-row class="self-font">适用流程：</el-row>
								<el-row>
									<el-form-item prop="applicationFlow2">
										<el-checkbox-group v-model="form.applicationFlow2">
										<el-checkbox label="2" name="applicationFlow2">轻打标</el-checkbox>
										<el-checkbox label="3" name="applicationFlow2">轻翻译</el-checkbox>
										<el-checkbox label="4" name="applicationFlow2">轻审核</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</el-row>
								<!-- <el-row class="self-font" v-if="form.infiledList2.find(it=>it.code === 1)?form.infiledList2.find(it=>it.code === 1).checked:false">
									<el-col>现金上限：</el-col>
									<el-col>
										<el-form-item prop="maxAmt">
											<el-input-number
														size="mini" auto-complete="off" :precision="2" :controls="false"
														v-model="form.maxAmt"
														:min="1" >
											</el-input-number>
											<span>元</span>
										</el-form-item>
									</el-col>
								</el-row> -->
								<el-form label-width="100px" size="mini" :model="form">
								<el-row v-show="this.$route.query.status === '2' || this.currentGlobalOperation !== null">
								<el-button type="primary" icon="el-icon-trophy-1" @click="awardVisible2Fn">获奖详情</el-button>
								<el-dialog :title="'天降惊喜 获奖人数：'+gridObj2.num + '      花费奖品：' +gridObj2.coin +'翼币     '+gridObj2.cardNum +'个翼卡   '+gridObj2.amt +'元现金'" :visible.sync="awardVisible2">
									<div slot="title" class="dialog-title">
									<el-row style="font-size: 18px">
										<el-col span="4"><span class="title-text">天降惊喜</span></el-col>
										<el-col span="4"><span>获奖人数:{{ gridObj2.num }}人</span></el-col>
										<el-col span="6"><span>花费奖品:{{ gridObj2.coin }}个翼币</span></el-col>
										<el-col span="4"><span>{{ gridObj2.cardNum }}张翼卡</span></el-col>
										<el-col span="4"><span>{{ gridObj2.amt }}元现金</span></el-col>
									</el-row>
									</div>
									<avue-crud ref="crud" :option="tableOption2" @size-change="sizeChange2" @current-change="currentChange2" @on-load="((page, params)=>{getList(page2,params,2)})" :data="gridData2" :page.sync="page2">
									<template slot="createTime" slot-scope="scope">
										<span>{{ scope.row.status !==1?(scope.row.createTime?formatDate(scope.row.createTime):'--'):'--' }}</span>
									</template>
									</avue-crud>
								</el-dialog>
								</el-row>
								</el-form>
							</el-main>
						</el-container>
					</el-collapse-item>
				</el-collapse>
			</el-form-item>
			<el-form-item prop="limitTime" v-show="form.checkedCities.length>0 || this.$route.query.status === '2'" >
				<span slot="label" class="slot-label f-s-18">三、活动时间</span>
				<el-date-picker
					v-model="form.limitTime"
					type="datetimerange"
					format='yyyy-MM-dd HH:mm'
					valueFormat='timestamp'
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:pickerOptions="pickerOptions"
					placeholder="选择任务截止时间">
				</el-date-picker>
			</el-form-item>
		</el-form>
		<el-row style="text-align: center" v-show="this.$route.query.status === '1' && form.checkedCities.length">
			<el-col :span="1" offset="10">
				<el-button type="primary" size="medium" @click="onSubmit('form')">发起审核</el-button>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-show="this.$route.query.status === '2'">
			<el-col :span="12" :offset="11">
				<el-button type="primary" plain @click="back">返回</el-button>
			</el-col>
		</el-row>
	</div>

</template>

<script>
import {toChinesNum, integerFn2, integerFn} from "@/util/util";
import {formatDate} from "@/util/date";
import {planOption, planOption2} from "@/const/crud/events/eventData";
import {listByRoleCode} from "@/api/centralControl/ongoingTask";
import {
	addOperationOverall,
	cardList,
	operationRewardOverallTjById,
	pageOperationRewardOverallById,
	queryOperationOverAll
} from "@/api/events/eventData";
import {mapState} from "vuex";

const cityOptions = [{label:'转盘奖励',value: '5'}, {label:'天降惊喜',value: '6'}];
export default {
  	props:['currentGlobalOperation'],
	data() {
		let validatePass = (rule, value, callback) => {
			if (value === ''|| value === null) {
				callback(new Error('请选择日期'));
			} else if (value && value.length>1 && value[0] < new Date().getTime() ) {
				callback(new Error('选择开始时间必须大于当前时间'));
			} else if (value && value.length>1 && value[1] < new Date().getTime() ) {
				callback(new Error('选择结束时间必须大于当前时间'));
			} else if(value && value.length > 1 && value[0] == value[1]) {
				callback(new Error('选择结束时间必须大于开始时间'));
			} else {
				callback();
			}
		};
		let validateMaxAmt = (rule, value, callback) => {
			if (value === '' || value === null) {
				callback(new Error('请填写现金上限'));
			} else if (!this.form.infiledList2[1].endValue){
				this.$message.error('现金不可为空');
			}else if (this.form.infiledList2.find(it => it.code === 1).checked
				&& this.form.infiledList2[1].content && !Number.isInteger(
				this.accDiv(value, this.form.infiledList2[1].content))) {
				callback(new Error('现金上限必须是现金奖励的整数倍'));
			} else if (value === 0) {
				callback(new Error('现金上限不能为0'));
			} else {
				callback();
			}
		};
		let validatePerTime = (rule, value, callback) => {
			if (value === '' || value === null || value === 0) {
				callback(new Error('请设置抽奖次数'));
			} else {
				callback();
			}
		};
		return {
			tempOrderDataList: [],
			actualAmt:null,
			actualCoin:null,
			status: '',
			selectRow:'',
			preViewFlag:this.$route.query.status === '2' || this.currentGlobalOperation !== null,
			rules: {
				perTime: [
				{ validator: validatePerTime, trigger: 'blur' }
				],
				maxAmt: [
				{ validator: validateMaxAmt, trigger: 'blur' }
				],
				applicationFlow: [
				{ type: 'array', required: true, message: '请至少选择一个适用流程', trigger: 'change' }
				],
				applicationFlow2: [
				{ type: 'array', required: true, message: '请至少选择一个适用流程', trigger: 'change' }
				],
				checkedCities: [
				{ type: 'array', required: true, message: '请至少选择一个方案', trigger: 'change' }
				],
				limitTime:[
				{ validator: validatePass, trigger: 'blur' }
				]
			},
			orderDataList:[],
			pmOptions: [],
			search: {
				text: '',
				pmId: '',
				sortType: null,
				riskLevel: null,
				language:null,
				pending:false
			},
			tableOption: planOption,
			tableOption2: planOption2,
			tableLoading: false,
			tableData: [],
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 10 // 每页显示多少条
			},
			page2: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 10 // 每页显示多少条
			},
			activeNames:[],
			drawsNum:1,
			checkAll: false,
			ykData:[],
			cities: cityOptions,
			isIndeterminate: true,
			awardVisible:false,
			awardVisible2:false,
			gridObj:{
			amt: 0,
			coin: 0,
			cardNum: 0,
			num: 0,
			operationNum: 0
			},
			gridObj2:{
				amt: 0,
				coin: 0,
				cardNum: 0,
				num: 0,
				operationNum: 0
			},
			gridData: [],
			gridData2: [],
			probabilityTotal: 0, //概率合计
			form: {
				maxAmt: null,
				perTime: 1,
				settleTime: null,
				drawsNum: 1,
				infiledList: [{
					cardId: 0,
					code: 0,
					prizeNum: '感谢参与',
					amt: 0,
					coin: 0,
					rewardNum: 1,
					percent:50,
					ykVisible: false
				},{
					cardId: 0,
					code: 1,
					percent:0,
					prizeNum: '一',
					amt: 0,
					coin: 0,
					rewardNum: 1,
					ykVisible: false
				},{
					cardId: 0,
					code: 2,
					percent:0,
					prizeNum: '二',
					amt: 0,
					coin: 0,
					rewardNum: 1,
					ykVisible: false
				}],
				infiledList2: [
				{checked: true, title: '', content: '无', limitValue: '无', percent: 50, unit: '', code: 0},
				{checked: false, title: '现金', startValue: 0, endValue: 0, limitValue: 0, percent: 0, unit: '元',code:1},
				{checked: false, title: '翼币', startValue: 0, endValue: 0, limitValue: 0, percent: 0, unit: '个',code:2},
				{checked: false, title: '铁卡', content: 1, limitValue: 1, percent: 0, unit: '张',code:3},
				{checked: false, title: '银卡', content: 1, limitValue: 1, percent: 0, unit: '张',code:4},
				{checked: false, title: '金卡', content: 1, limitValue: 1, percent: 0, unit: '张',code:5}],
				checkedCities: [],
				limitTime: '',
				endTime: '',
				planId: '',
				type: [],
				planId2: '',
				applicationFlow: [],
				applicationFlow2: [],
				status: 1,
			},
			form3:{},
			dataList:[
				{
				status:1,
				planId:1,
				planDetailList:[
					{startSort:1,sort:1,endSort:5,amt:0,coin:0},
					{startSort:6,sort:2,endSort:10,amt:0,coin:0},
					{startSort:11,sort:3,endSort:20,amt:0,coin:0}
				]
				},
				{
				status:1,
				planId:1,
				planDetailList:[
					{startSort:1,sort:1,endSort:5,amt:0,coin:0},
					{startSort:6,sort:2,endSort:10,amt:0,coin:0},
					{startSort:11,sort:3,endSort:20,amt:0,coin:0}
				]
				},
				{
				status:1,
				planId:1,
				planDetailList:[
					{startSort:1,sort:1,endSort:5,amt:0,coin:0},
					{startSort:6,sort:2,endSort:10,amt:0,coin:0},
					{startSort:11,sort:3,endSort:20,amt:0,coin:0}
				]
				}
			],
			pickerOptions: {
				disabledDate(time) {
				return time.getTime() < Date.now() - 8.64e7;
				},
			},
		}
	},
	computed: {
		...mapState({
			userInfo: state => state.user.userInfo
		}),
	},
	beforeCreate() {
		if (this.$route.query.status === "2") {//查看详情
			queryOperationOverAll({operationId:this.$route.query.id}).then(res=>{
				let val = res.data.data;
				if (val) {
					this.status = val.status;
					this.form.checkedCities = val.planList.map(i => i.type + '');
					this.form.limitTime = [parseFloat(val.startTime),parseFloat(val.endTime)];
					this.activeNames = this.form.checkedCities;
					this.actualCoin = val.coin;
					this.actualAmt = val.amt;
					if (this.form.checkedCities.includes('5')) {
						let find = val.planList.find(i=>i.type===5);
						this.planId = find.id;
						find.planDetailList.map((i, ind) => i.prizeNum = ind===0?'感谢参与':toChinesNum(ind));
						this.form.perTime = find.perTime;
						this.$set(this.form, 'infiledList', find.planDetailList);
						this.form.applicationFlow = find.applicationFlow.split(',')
					}
					if (this.form.checkedCities.includes('6')) {
						let find = val.planList.find(i=>i.type===6);
						this.planId2 = find.id;
						this.form.maxAmt = find.maxAmt;
						find.planDetailList.forEach(it => {
							it.checked = true
							if (it.code === 0) {
								it.unit = '';
								it.title = '';
							} else if (it.code === 1) {
								it.unit = '元';
								it.title = '现金';
							} else if (it.code === 2) {
								it.unit = '个';
								it.title = '翼币';
							} else if (it.code === 3) {
								it.unit = '张';
								it.title = '铁卡';
							} else if (it.code === 4) {
								it.unit = '张';
								it.title = '银卡';
							} else {
								it.unit = '张';
								it.title = '金卡';
							}
						});
						this.$set(this.form, 'infiledList2', find.planDetailList);
						this.form.applicationFlow2 = find.applicationFlow.split(',')
					}
				} else {
					this.$message.error("查看活动详情错误")
				}
			})
		}
	},
	watch:{
		currentGlobalOperation(val, oldVal) {
			if (val) {
				this.status = val.status;
				this.form.checkedCities = val.planList.map(i => i.type + '');
				this.form.limitTime = [parseFloat(val.startTime),parseFloat(val.endTime)];
				this.activeNames = this.form.checkedCities;
				this.actualCoin = val.coin;
				this.actualAmt = val.amt;
				if (this.form.checkedCities.includes('5')) {
					let find = val.planList.find(i=>i.type===5);
					this.planId = find.id;
					find.planDetailList.map((i, ind) => i.prizeNum = ind===0?'感谢参与':toChinesNum(ind));
					this.form.perTime = find.perTime;
					this.$set(this.form, 'infiledList', find.planDetailList);
					this.form.applicationFlow = find.applicationFlow.split(',')
				}
				if (this.form.checkedCities.includes('6')) {
					let find2 = val.planList.find(i=>i.type===6);
					this.planId2 = find2.id;
					this.form.maxAmt = find2.maxAmt;
					find2.planDetailList.forEach(it => {
						it.checked = true
						if (it.code === 0) {
							it.unit = '';
							it.title = '';
						} else if (it.code === 1) {
							it.unit = '元';
							it.title = '现金';
						} else if (it.code === 2) {
							it.unit = '个';
							it.title = '翼币';
						} else if (it.code === 3) {
							it.unit = '张';
							it.title = '铁卡';
						} else if (it.code === 4) {
							it.unit = '张';
							it.title = '银卡';
						} else {
							it.unit = '张';
							it.title = '金卡';
						}
					});
					this.$set(this.form, 'infiledList2', find2.planDetailList);
					this.form.applicationFlow2 = find2.applicationFlow.split(',')
				}
			} else {
				this.$message.error("查看活动详情错误")
			}
		},
		'form.checkedCities':function (val) {
		}
	},
	mounted() {
		cardList().then(res=>{
			this.ykData = res.data.data;
		})
	},
	beforeMount() {
		listByRoleCode(Object.assign({
			roleCode: "DOT_PM"
		})).then(res => {
		let result = res.data.data;
		this.pmOptions = result.map(it => {
			return {
				value: it.staffId,
				label: it.realname,
				username: it.username
			}
		});
		})

	},
	methods:{
		back() {
			let activeName = this.$route.query.activeName;
			// this.$message.success(activeName);
			// this.$router.back();
			this.$router.push({path: '/events/globalEvent', query: {activeName: activeName}});
		},

		accDiv(arg1, arg2) {
			let t1 = 0, t2 = 0, r1, r2;
			try {
				t1 = arg1.toString().split(".")[1].length
			} catch (e) {
			}   //--小数点后的长度
			try {
				t2 = arg2.toString().split(".")[1].length
			} catch (e) {
			}  //--小数点后的长度
			r1 = Number(arg1.toString().replace(".", ""))  //--去除小数点变整数
			r2 = Number(arg2.toString().replace(".", ""))  //--去除小数点变整数
			return (r1 / r2) * Math.pow(10, t2 - t1);   //---整数相除 在乘上10的平方  小数点的长度
		},

		integerFn(val) {
			return integerFn(val);
		},

		integerFn2(val) {
			return integerFn2(val);
		},
		formatDate(time) {
			let date = new Date(parseFloat(time))
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		},

		awardVisibleFn() {
			// todo awardVisibleFn
			operationRewardOverallTjById({planId:this.planId}).then(res=>{
				// this.gridData = res.data.data;
				this.gridObj = res.data.data;
			})
			this.awardVisible = true;
			this.getList(this.page,null,1)
		},

		awardVisible2Fn() {
			operationRewardOverallTjById({planId:this.planId2}).then(res=>{
				// this.gridData2 = res.data.data;
				this.gridObj2 = res.data.data;
			})
			this.awardVisible2 = true;
			this.getList(this.page2,null,2)
		},

		checkAnyEmpty(objList) {
			let arr = [];
			objList.forEach(it=>{
				for (const key in it) {
					arr.push(it[key])
				}
			})
			return arr.includes('');
		},

		checkAnyZero(objList) {
			let arr = [];
			objList.forEach(it=>{
				for (const key in it) {
					arr.push(it[key])
				}
			})
			return arr.includes(0);
		},

		checkAllZero(objList,rewardNumList) {
			let arr = [];
			objList.forEach(it=>{
				let sum = 0;
				for (const key in it) {
					sum += it[key] ? it[key] : 0;
				}
				arr.push(sum)
			})
			return arr.includes(0) || (!arr.includes(0) && (rewardNumList.includes(0) || rewardNumList.includes('')));
		},

		//概率合计
		checkType(e) {
			this.probabilityTotal = this.form.infiledList2.filter(item=>item.checked)
									.map(item=>item.percent)
									.reduce((prev, cur)=>{
										return (parseFloat(Number(prev)) + parseFloat(Number(cur))).toFixed(2)
									})
		},

		onSubmit(formName) {
			let res = this.checkAllZero(this.form.infiledList.slice(1).map(it=>{return {amt:it.amt,coin:it.coin,cardId:it.cardId}}),this.form.infiledList.map(it=>it.rewardNum));
			let res2 = this.checkAnyZero(this.form.infiledList2.filter(it=>it.checked).map(it=>{return {endValue: it.endValue}}));
			let rangeArr = this.form.infiledList2.filter(item=>item.checked).map(item=>{
				return item.endValue < item.startValue
			})
			let res3 = rangeArr.some(item=>{
				return item==true
			})
			let limitRangeArr = this.form.infiledList2.filter(item=>item.checked).map(item=>{
				return item.limitValue < item.endValue || item.limitValue < item.content
			})
			let res4 = limitRangeArr.some(item=>{
				return item==true
			})
			let res5 = this.checkAnyZero(this.form.infiledList2.filter(item=>item.checked).map(item=>{
				return { percent: item.percent }
			}))
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let msg = '';
					let dotOperation = {
						createId: this.userInfo.staffCode,
						startTime: this.form.limitTime[0],
						endTime: this.form.limitTime[1],
						planType:this.form.checkedCities.join()
					};
					let planList = [];
					if (this.form.checkedCities.includes('5')) {
						if (res) {
							this.$message.error('转盘奖励每个奖项中的三个内容（现金奖励、翼币、翼卡）至少要填有一项内容且奖励个数必须大于0！');
							return;
						}
						if(Number(this.form.infiledList[0].percent <= 0)) {
							this.$message.error('感谢参与的出现概率不能为0！');
							return;
						} 
						let percentSum = this.form.infiledList.map(it => it.percent).reduce((c, R) => parseFloat(c) + parseFloat(R), 0);
						if (parseFloat(percentSum).toFixed(2) !== '100.00') {
							this.$message.error('转盘奖励概率之和不为100%！');
							return;
						}
						planList.push({
							perTime:this.form.perTime,
							type: 5,
							applicationFlow:this.form.applicationFlow.join(),
							planDetailList:this.form.infiledList
						})
					}
					if (this.form.checkedCities.includes('6')) {
						if (this.form.infiledList2.filter(it=>it.checked).length === 1) {
							this.$message.error('天降惊喜必须至少勾选现金、翼币、翼卡(金卡、银卡、铁卡)中的一项');
							return
						}
						if(Number(this.form.infiledList2[0].percent <= 0)) {
							this.$message.error('类型为无的出现概率不能为0！');
							return;
						}
						if (res2) {
							this.$message.error('天降惊喜已勾选的每个奖项中的获奖内容必须大于0！');
							return;
						}
						if(res3) {
							this.$message.error('天降惊喜已勾选的每个奖项中的获奖内容区间值填写有误！');
							return;
						}
						if(res4) {
							this.$message.error('天降惊喜已勾选的每个奖项中的奖励上限填写有误！');
							return;
						}
						if(res5) {
							this.$message.error('天降惊喜已勾选的每个奖项中的出现概率必须大于0！');
							return;
						}
						let percentSum = this.form.infiledList2.filter(it => it.checked).map(it => it.percent).reduce((c, R) => parseFloat(c) + parseFloat(R), 0);
						if (parseFloat(percentSum).toFixed(2) !== '100.00') {
							this.$message.error('天降惊喜已勾选的每个奖项的出现概率之和不为100%！');
							return;
						}
						if (this.form.infiledList2.find(it => it.code === 1).checked) {
							planList.push({
								maxAmt: this.form.maxAmt,
								type: 6,
								applicationFlow: this.form.applicationFlow2.join(),
								planDetailList: this.form.infiledList2.filter(it => it.checked === true)
							});
						} else {
							planList.push({
								type: 6,
								applicationFlow: this.form.applicationFlow2.join(),
								planDetailList: this.form.infiledList2.filter(it => it.checked === true)
							});
						}
					}
					dotOperation.planList = planList;
					this.$confirm('活动审核通过以后,会自动发布,是否发起审核', '提示', {
						dangerouslyUseHTMLString: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						addOperationOverall(dotOperation).then(res=>{
							let code = res.data.data;
							if (code > 0) {
								this.$message({
									type: 'success',
									message: '发布成功!'
								});
								this.$router.go(-1);
							} else if (code === -1){
								this.$message.error("参数不能为空");
							} else if (code === -2){
								this.$message.error("存在审批中活动");
							} else if (code === -3) {
								this.$message.error("活动时间存在交叉");
							} else {
								this.$message.error("未知错误，请联系系统管理员");
							}
						})
					}).catch(() => {

					});
				} else {
					this.$message.info("请填写正确内容后发起审核")
					return false;
				}
			});
		},

		refreshChange() {
			this.getList()
		},
		getList(page, params,type) {
			this.tableLoading = true
			let target = {
				current: page.currentPage,
				size: page.pageSize,
				planId: type === 1 ? this.planId : this.planId2
			}
			pageOperationRewardOverallById(Object.assign(target,params)).then(res=>{
				if (type===1) {
					this.gridData = res.data.data.records;
					this.page.total = res.data.data.total;
				} else {
					this.gridData2 = res.data.data.records;
					this.page2.total = res.data.data.total;
				}
				this.tableLoading = false
			})
		},

		searchChange(form, done) {
			// console.log(form)
			this.form3 = form
			// this.page.currentPage = 1;//避免翻页了再搜索为空的情况，明明应该有数据
			this.getList(this.page, form)
			done()
		},

		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},

		currentChange(current) {
			this.page.currentPage = current
		},

		sizeChange2(pageSize) {
			this.page2.pageSize = pageSize
		},

		currentChange2(current) {
			this.page2.currentPage = current
		},

		handleChange(val) {
		},

		deleteRow(index, rows) {//删除该行
			if (index === 6) {
				rows.splice(index - 1, 2);
			} else {
				rows.splice(index, 1);
			}
		},

		addRow(tableData,type){
			if (type===1) {
				if (tableData.length===5) {
					tableData.push({
						cardId: 0,
						prizeNum: toChinesNum(tableData.length),
						amt: 0,
						code: tableData.length,
						coin: 0,
						percent:0,
						rewardNum: 1,
						ykVisible:false
					});
				}
				tableData.push({
					cardId: 0,
					prizeNum: toChinesNum(tableData.length),
					amt: 0,
					code: tableData.length,
					coin: 0,
					percent:0,
					rewardNum: 1,
					ykVisible:false
				});
			} else {
				tableData.push({
					prizeNum: toChinesNum(tableData.length),
					amt: 0,
					sort: tableData.length+1,
					coin: 0,
					rewardNum: 1
				});
			}
		},
		
		handleCheckAllChange(val) {
			this.form.checkedCities = val ? ['5','6'] : [];
			this.activeNames = this.form.checkedCities;
			this.isIndeterminate = false;
		},

		handleCheckedCitiesChange(value) {
			this.activeNames = value;
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.cities.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
		},

		init() {},
	},
	
}

</script>

<style>
.self-input span {
  color: red;
}
.self-input .el-input__inner {
  width: 80px;
}
.self-input .self-mini .el-input__inner {
  width: 70px;
}
.self-input .el-input--mini{
  width: auto;
}
.self-yuan {
  padding: 0 20px;
  background-color: #F5F7FA;
  border: 1px solid #DCDFE6;
  border-left: 0;
  border-radius: 4px;
  color: #909399;
}
</style>
<style lang='scss' scoped>
.totalBox {
	width: 95%;
	text-align: right;
	padding: 10px;
	font-size: 14px;
	font-weight: 600;
}
.rangeBox {
	.self-num {
		border-radius: 0 4px 4px 0;
		padding: 0 20px;
		background-color: #F5F7FA;
		border: 1px solid #DCDFE6;
		border-left: 0;
		color: #909399;
		height: 28px;
		line-height: 28px;
	}
}
:deep(.el-collapse-item__header){
  font-size: large;
  font-weight: 500;
}
.self-add {
	width: 95%;
  	text-align: center;
  	font-size: x-large;
	border: 1px solid #EBEEF5;
	border-top: none;
	i {
		cursor: pointer;
		color: #606266;
		&:hover {
			color: #409EFF;
		}
	}
}
.self-font{
  font-size: 18px;
  font-weight: 600;
}
:deep(.slot-label){
  font-size: x-large
}
.self-col{
  display: flex;
  justify-content: space-around
}
:deep(.el-input-number.is-without-controls .el-input__inner) {
  text-align: left;
  line-height: 30px;
  height: 28px;
}
:deep(.el-input-number--mini){
  width: 91%;
}
</style>
